<template>
  <dialog-order-edit
    v-if="$route.matched.some(r => r.name === 'promotion-details')"
    :is-on="true"
    :is-business="isBusiness"
    :order="selectedOrder"
    :is-editing-order="isEditingOrder"
    :can-edit-details="canEditDetails"
    :on-cancel="onCancel"
    :on-confirm="updateOrder"
    :is-loading-order="isLoadingOrder"
    :on-toggle="toggleEditDetails"
    :on-change-status="updateStatus"
  />

  <router-view />
</template>

<script>
  import fetchIfNotInStore from '@/mixins/fetchIfNotInStore';

  export default {
    mixins: [fetchIfNotInStore],
    data() {
      return {
        selectedOrder: {},
        isLoadingOrder: false,
        isEditingOrder: false,
        canEditDetails: false,
      };
    },
    computed: {
      orderId() {
        return Number(this.$route.params.id);
      },
      isBusiness() {
        return this.$ability.can('view-business-contact', 'ad-manager.order');
      },
      canUpdateOrder() {
        return this.$ability.can('update', 'ad-manager.order') || this.$store.getters['auth/user']?.business_id;
      },
      storeActiveItem() {
        return this.$store.getters['promotions/activeItem'];
      },
    },
    watch: {
      orderId(id) {
        if (id) this.loadOrder();
      },
      storeActiveItem(newItem) {
        if (newItem?.id === this.orderId) {
          this.selectedOrder = newItem;
        }
      },
    },
    created() {
      this.loadOrder();
    },
    methods: {
      async loadOrder() {
        if (!this.orderId) return;
        this.isLoadingOrder = true;
        try {
          const order = await this.fetchIfNotInStore(this.orderId, 'promotions', 'items', 'getOrder');
          if (order) this.selectedOrder = order;
          await this.$store.dispatch('promotions/setActiveOrder', order);
          if (this.isBusiness && order?.business?.id && order?.advertiser?.id) {
            this.getBusinessPlacements(order.business.id, order.advertiser.id, order.country?.code);
          }
        } catch (err) {
          this.onCancel();
        } finally {
          this.isLoadingOrder = false;
        }
      },
      onCancel() {
        this.$router.push({ name: 'promotions' });
      },
      toggleEditDetails() {
        this.canEditDetails = !this.canEditDetails;
      },
      async updateOrder(order) {
        if (!this.canUpdateOrder) return undefined;

        const nextOrder = {
          ...order,
          country: this.selectedOrder.country.code,
          id: this.selectedOrder.id,
          isBC: this.isBusiness,
        };

        this.isEditingOrder = true;

        return this.$store.dispatch('promotions/updateOrder', nextOrder)
          .then((res) => {
            this.$router.push({ name: 'promotions', query: { status: 'success' } });
            return res;
          })
          .finally(() => {
            this.isEditingOrder = false;
          });
      },
      async updateStatus(status) {
        if (!this.canUpdateOrder) return undefined;

        const nextOrder = {
          ...status,
          id: this.selectedOrder.id,
          statusId: status.id,
          isBC: this.isBusiness,
        };

        this.isEditingOrder = true;

        return this.$store.dispatch('promotions/updateStatus', nextOrder)
          .then((res) => {
            this.$router.push({ name: 'promotions', query: { status: 'success' } });
            return res;
          })
          .finally(() => {
            this.isEditingOrder = false;
          });
      },
      getBusinessPlacements(business_id, advertiser_id, country) {
        return this.$store.dispatch('businesses/getBusinessPlacements', { business_id, advertiser_id, country })
          .then((res) => res.placements)
          .catch((err) => err);
      },
    },
  };
</script>
